module.exports = __webpack_public_path__ + "static/media/load-doc.116b7d0a.svg";